import React, {useEffect, useMemo, useState} from "react";
import {Button, Card, Col, Container, FormGroup, Label, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import DataTable from "react-data-table-component";
import MiniGameFilter from "components/Custom/MiniGameFilter";
import DraggableImagesMini4 from "components/Custom/DraggableImagesMini4";
import QuestionActions from "components/Custom/QuestionActions";
import QuestionnaireModalRenderer from "../../components/Custom/QuestionnaireModalRenderer";
import DraggableImagesMini8 from "../../components/Custom/DragableImagesMini8";
import {filterMiniGames, getDb} from "../../util/Constants";

import {collection, deleteDoc, doc, getDocs, query, updateDoc, where,} from "firebase/firestore";
import "../../assets/css/questionnaire.css";
import Swal from "sweetalert2";
import {getDownloadURL, getStorage, listAll, ref} from "firebase/storage";

// --- Component ---
export default function Questionnaire() {
  // --- State ---
  const [selectedMiniGame, setSelectedMiniGame] = useState("");
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editRowId, setEditRowId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // MiniGame 4/5
  const [editedQuestion, setEditedQuestion] = useState("");
  const [editedMCQ, setEditedMCQ] = useState([]);
  const [editedAnswer, setEditedAnswer] = useState("");
  const [editedOptions, setEditedOptions] = useState([]);
  const [addNewImagesIn4, setAddNewImagesIn4] = useState(false);
  const [fetchingNewImages, setFetchingNewImages] = useState(false);
  const [allNewImages, setAllNewImages] = useState([]);
  const [newlySelectedImages, setNewlySelectedImages] = useState([]);

  const fetchImages = async () => {
    const storage = getStorage();
    const folderRef = ref(storage, "Mini4");
    const res = await listAll(folderRef);
    const urls = await Promise.all(
      res.items.map(async (itemRef) => {
        const url = await getDownloadURL(itemRef);
        return { name: itemRef.name, url };
      })
    );
    setFetchingNewImages(false)
    setAllNewImages(urls);
  };

  useEffect(() => {
    if (!addNewImagesIn4) return;
    fetchImages();
    setNewlySelectedImages([]);
  }, [addNewImagesIn4]);


  // MiniGame 7
  const [editedWeightBlue, setEditedWeightBlue] = useState("");
  const [editedWeightGreen, setEditedWeightGreen] = useState("");
  const [editedWeightRed, setEditedWeightRed] = useState("");
  const [editedWeightYellow, setEditedWeightYellow] = useState("");
  const [editedS1Limit, setEditedS1Limit] = useState("");
  const [editedS2Limit, setEditedS2Limit] = useState("");

  // MiniGame 8
  const [editedSequence, setEditedSequence] = useState([]);

  // MiniGame 9
  const [editedChartType, setEditedChartType] = useState("");
  const [editedMini9Question, setEditedMini9Question] = useState("");
  const [editedMini9MCQ, setEditedMini9MCQ] = useState([]);
  const [editedMini9Answer, setEditedMini9Answer] = useState("");
  const [editedMini9Title, setEditedMini9Title] = useState("");
  const [editedMini9XAxis, setEditedMini9XAxis] = useState([]);
  const [editedMini9YAxis, setEditedMini9YAxis] = useState([]);

  // MiniGame 10
  const [editedCorrectSequence, setEditedCorrectSequence] = useState([]);
  const [editedWrongSequence, setEditedWrongSequence] = useState([]);

  // --- Handlers ---

  // General
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleMiniGameChange = async (e) => {
    const value = e.target.value;
    console.log("selected mini game", value);

    setSelectedMiniGame(value);
    setQuestions([]);
    if (value) {
      setLoading(true);
      try {
        const q = query(
          collection(getDb(), "questions"),
          where("miniGame", "==", `Mini ${value}`)
        );
        const querySnapshot = await getDocs(q);
        const docs = [];
        querySnapshot.forEach((doc) => {
          docs.push({ id: doc.id, ...doc.data() });
        });
        setQuestions(docs);
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
      setLoading(false);
    }
  };

  const handleQuestionAdded = async () => {
    if (selectedMiniGame) {
      await handleMiniGameChange({ target: { value: selectedMiniGame } });
    }
  };


  const customStyles = {
    rows: {
      style: {
        minHeight: "30px",      // override the row minHeight
        // paddingTop: "4px",      // optional—tinker to taste
        // paddingBottom: "4px",
        padding: 0,
        margin: 0,
        // maxHeight: "100px"
      },
    },
    cells: {
      style: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  }

  // --- MiniGame 3 ---
  const handleEditMini3 = (row) => {
    setEditRowId(row.id);
    setEditedQuestion(row.question || "");
  };

  const handleUpdateMini3 = async (row) => {
    try {
      await updateDoc(doc(getDb(), "questions", row.id), {
        question: editedQuestion,
      });
      setQuestions((prev) =>
        prev.map((q) =>
          q.id === row.id ? { ...q, question: editedQuestion } : q
        )
      );
      setEditRowId(null);
      setEditedQuestion("");
      await Swal.fire("Updated!", "The question has been updated.", "success");
    } catch (error) {
      await Swal.fire("Error!", "Failed to update the question.", "error");
    }
  };

  // --- MiniGame 4 ---

  useEffect(() => {
    console.log("newlySelectedImages", newlySelectedImages);

  }, [newlySelectedImages])

  const handleEditMini4 = (row) => {
    setEditRowId(row.id);
    setEditedQuestion(row.question || "");
    console.log("row.options on start edit", row.options);
    setEditedOptions(row.options || []);
  };
  const handleRemoveOptionImage = (idx) => {
    setEditedOptions((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleAddNewImage = (img) => {
    console.log("img", img);

    if (!newlySelectedImages.find((i) => i.name === img.name)) {
      setNewlySelectedImages([...newlySelectedImages, img]);
    }

    if (!editedOptions.includes(img.url)) {
      setEditedOptions((prev) => [...prev, img.url]);
    }

    setAddNewImagesIn4(false)

  };


  const handleUpdateMini4 = async (row) => {
    try {
      await updateDoc(doc(getDb(), "questions", row.id), {
        question: editedQuestion,
        options: editedOptions,
        mini4Options: String(editedOptions.length),
      });
      setQuestions((prev) =>
        prev.map((q) =>
          q.id === row.id
            ? {
              ...q,
              question: editedQuestion,
              options: editedOptions,
              mini4Options: String(editedOptions.length),
            }
            : q
        )
      );
      setEditRowId(null);
      setEditedQuestion("");
      setEditedOptions([]);
      await Swal.fire("Updated!", "The question has been updated.", "success");
    } catch (error) {
      await Swal.fire("Error!", "Failed to update the question.", "error");
    }
  };

  // --- MiniGame 5 ---
  const handleEditMini5 = (row) => {
    setEditRowId(row.id);
    setEditedQuestion(row.question || "");
    setEditedMCQ(row.mcq || []);
    setEditedAnswer(row.answer || "");
  };

  const handleUpdateMini5 = async (row) => {
    try {
      await updateDoc(doc(getDb(), "questions", row.id), {
        question: editedQuestion,
        mcq: editedMCQ,
        answer: editedAnswer,
      });
      setQuestions((prev) =>
        prev.map((q) =>
          q.id === row.id
            ? {
              ...q,
              question: editedQuestion,
              mcq: editedMCQ,
              answer: editedAnswer,
            }
            : q
        )
      );
      setEditRowId(null);
      setEditedQuestion("");
      setEditedMCQ([]);
      setEditedAnswer("");
      await Swal.fire("Updated!", "The question has been updated.", "success");
    } catch (error) {
      await Swal.fire("Error!", "Failed to update the question.", "error");
    }
  };

  // --- MiniGame 6 ---
  const handleEditMini6 = (row) => {
    setEditRowId(row.id);
    setEditedQuestion(row.paragraph || "");
    setEditedMCQ(row.mcqs || []);
    setEditedAnswer(row.correctAnswer || "");
  };

  const handleUpdateMini6 = async (row) => {
    try {
      await updateDoc(doc(getDb(), "questions", row.id), {
        paragraph: editedQuestion,
        mcqs: editedMCQ,
        correctAnswer: editedAnswer,
      });
      setQuestions((prev) =>
        prev.map((q) =>
          q.id === row.id
            ? {
              ...q,
              paragraph: editedQuestion,
              mcqs: editedMCQ,
              correctAnswer: editedAnswer,
            }
            : q
        )
      );
      setEditRowId(null);
      setEditedQuestion("");
      setEditedMCQ([]);
      setEditedAnswer("");
      await Swal.fire("Updated!", "The question has been updated.", "success");
    } catch (error) {
      await Swal.fire("Error!", "Failed to update the question.", "error");
    }
  };

  // --- MiniGame 7 ---
  const handleEditMini7 = (row) => {
    setEditRowId(row.id);
    setEditedQuestion(row.Description || "");
    setEditedWeightBlue(row.WeightBlue?.toString() || "");
    setEditedWeightGreen(row.WeightGreen?.toString() || "");
    setEditedWeightRed(row.WeightRed?.toString() || "");
    setEditedWeightYellow(row.WeightYellow?.toString() || "");
    setEditedS1Limit(row.s1Limit?.toString() || "");
    setEditedS2Limit(row.s2Limit?.toString() || "");
  };

  const handleUpdateMini7 = async (row) => {
    try {
      await updateDoc(doc(getDb(), "questions", row.id), {
        Description: editedQuestion,
        WeightBlue: Number(editedWeightBlue),
        WeightGreen: Number(editedWeightGreen),
        WeightRed: Number(editedWeightRed),
        WeightYellow: Number(editedWeightYellow),
        s1Limit: Number(editedS1Limit),
        s2Limit: Number(editedS2Limit),
      });
      setQuestions((prev) =>
        prev.map((q) =>
          q.id === row.id
            ? {
              ...q,
              Description: editedQuestion,
              WeightBlue: Number(editedWeightBlue),
              WeightGreen: Number(editedWeightGreen),
              WeightRed: Number(editedWeightRed),
              WeightYellow: Number(editedWeightYellow),
              s1Limit: Number(editedS1Limit),
              s2Limit: Number(editedS2Limit),
            }
            : q
        )
      );
      setEditRowId(null);
      setEditedQuestion("");
      setEditedWeightBlue("");
      setEditedWeightGreen("");
      setEditedWeightRed("");
      setEditedWeightYellow("");
      setEditedS1Limit("");
      setEditedS2Limit("");
      await Swal.fire("Updated!", "The question has been updated.", "success");
    } catch (error) {
      await Swal.fire("Error!", "Failed to update the question.", "error");
    }
  };

  // --- MiniGame 8 ---
  const handleEditMini8 = (row) => {
    console.log("row", row);

    setEditRowId(row.id);
    setEditedSequence(row.sequence || []);
  };

  const handleUpdateMini8 = async (row) => {
    try {
      console.log("editedSequence", editedSequence);

      await updateDoc(doc(getDb(), "questions", row.id), {
        sequence: editedSequence,
      });
      setQuestions((prev) =>
        prev.map((q) =>
          q.id === row.id ? { ...q, sequence: editedSequence } : q
        )
      );
      setEditRowId(null);
      setEditedSequence([]);
      await Swal.fire("Updated!", "The sequence has been updated.", "success");
    } catch (error) {
      await Swal.fire("Error!", "Failed to update the sequence.", "error");
    }
  };

  // --- MiniGame 9 ---
  const handleEditMini9 = (row) => {
    setEditRowId(row.id);
    setEditedChartType(row.chartType || "");
    setEditedMini9Question(row.question || "");
    setEditedMini9MCQ(row.mcqs || []);
    setEditedMini9Answer(row.answer || "");
    setEditedMini9Title(row.title || "");
    setEditedMini9XAxis(
        Array.isArray(row.xaxis)
            ? row.xaxis.map(item => String(item))
            : []
    );
    setEditedMini9YAxis(
        Array.isArray(row.yaxis)
            ? row.yaxis.map(item => String(item))
            : []
    );
  };

  const handleUpdateMini9 = async (row) => {
    try {
      // Convert X axis strings to numbers if horizontalbar chart type
      const xaxisToSave = editedChartType === "horizontalbar"
          ? editedMini9XAxis.map(val => {
            const num = parseFloat(val);
            return isNaN(num) ? val : num;
          })
          : editedMini9XAxis;

      // Convert Y axis strings to numbers if not horizontalbar chart type
      const yaxisToSave = editedChartType === "horizontalbar"
          ? editedMini9YAxis
          : editedMini9YAxis.map(val => {
            const num = parseFloat(val);
            return isNaN(num) ? val : num;
          });
      
      await updateDoc(doc(getDb(), "questions", row.id), {
        chartType: editedChartType,
        question: editedMini9Question,
        mcqs: editedMini9MCQ,
        answer: editedMini9Answer,
        title: editedMini9Title,
        xaxis: xaxisToSave,
        yaxis: yaxisToSave,
      });
      setQuestions((prev) =>
        prev.map((q) =>
          q.id === row.id
            ? {
                ...q,
                chartType: editedChartType,
                question: editedMini9Question,
                mcqs: editedMini9MCQ,
                answer: editedMini9Answer,
                title: editedMini9Title,
                xaxis: xaxisToSave,
                yaxis: yaxisToSave,
              }
            : q
        )
      );
      setEditRowId(null);
      setEditedChartType("");
      setEditedMini9Question("");
      setEditedMini9MCQ([]);
      setEditedMini9Answer("");
      setEditedMini9Title("");
      setEditedMini9XAxis([]);
      setEditedMini9YAxis([]);
      await Swal.fire("Updated!", "The question has been updated.", "success");
    } catch (error) {
      await Swal.fire("Error!", "Failed to update the question.", "error");
    }
  };

  // --- MiniGame 10 ---
  const handleEditMini10 = (row) => {
    setEditRowId(row.id);
    setEditedCorrectSequence(row.correctSequence || []);
    setEditedWrongSequence(row.wrongSequence || []);
  };

  const handleUpdateMini10 = async (row) => {
    try {
      await updateDoc(doc(getDb(), "questions", row.id), {
        correctSequence: editedCorrectSequence,
        wrongSequence: editedWrongSequence,
      });
      setQuestions((prev) =>
        prev.map((q) =>
          q.id === row.id
            ? {
              ...q,
              correctSequence: editedCorrectSequence,
              wrongSequence: editedWrongSequence,
            }
            : q
        )
      );
      setEditRowId(null);
      setEditedCorrectSequence([]);
      setEditedWrongSequence([]);
      await Swal.fire("Updated!", "The sequence has been updated.", "success");
    } catch (error) {
      await Swal.fire("Error!", "Failed to update the sequence.", "error");
    }
  };

  // --- General Handlers ---
  const handleCancel = () => {
    setEditRowId(null);
    setEditedMCQ([]);
    setEditedAnswer("");
    setEditedSequence([]);
  };

  const handleDelete = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });
    if (!result.isConfirmed) return;
    try {
      await deleteDoc(doc(getDb(), "questions", row.id));
      setQuestions((prev) => prev.filter((q) => q.id !== row.id));
      await Swal.fire("Deleted!", "The question has been deleted.", "success");
    } catch (error) {
      await Swal.fire("Error!", "Failed to delete the question.", "error");
    }
  };

  // --- Utility ---
  const renderAddButton = () =>
    selectedMiniGame ? (
      <Button color="primary" onClick={toggleModal}>
        Add
      </Button>
    ) : null;

  const defaultPerPage = useMemo(() => {
    return selectedMiniGame == 3 ? 50 : 10;
  }, [selectedMiniGame]);

  const columns =
    selectedMiniGame === "3"
      ? [
        {
          name: "Question",
          cell: (row) =>
            editRowId === row.id ? (
              <input
                type="text"
                value={editedQuestion}
                onChange={(e) => setEditedQuestion(e.target.value)}
                className="mini-game-3-input"
              />
            ) : (
              <div className="mini-game-3-display">{row.question}</div>
            ),
          wrap: true,
          width: "80%",
        },
        {
          name: "Actions",
          cell: (row) =>
            editRowId === row.id ? (
              <QuestionActions
                isEditing={true}
                onUpdate={() => handleUpdateMini3(row)}
                onCancel={handleCancel}
                row={row}
                disableUpdate={
                  editedQuestion.trim() === (row.question || "").trim()
                }
              />
            ) : (
              <QuestionActions
                isEditing={false}
                onEdit={() => handleEditMini3(row)}
                onDelete={() => handleDelete(row)}
                row={row}
              />
            ),
          ignoreRowClick: true,
          allowOverflow: true,
          button: true,
          minWidth: "15%",
        },
      ]
      : selectedMiniGame === "4"
        ? [
          {
            name: "mini4Options",
            selector: (row) => row.mini4Options,
            sortable: false,
            width: "10%",
            style: { textAlign: "center" },
          },
          {
            name: "Question",
            cell: (row) =>
              editRowId === row.id ? (
                <textarea
                  value={editedQuestion}
                  onChange={(e) => setEditedQuestion(e.target.value)}
                  rows={1}
                  style={{ width: "100%", minHeight: 60 }}
                />
              ) : (
                row.question
              ),
            wrap: true,
            width: "30%",
          },
          {
            name: "Options",
            cell: (row) =>
              editRowId === row.id ? (
                <div className="image-grid selected" style={{ marginTop: 16 }}>
                  <DraggableImagesMini4
                    row={row}
                    showCross={true}
                    handleRemoveOptionImage={handleRemoveOptionImage}
                    editedOptions={editedOptions}
                    setEditedOptions={setEditedOptions}
                  />
                  <div
                    className="add-badge-primary"
                    style={{ marginTop: '20px' }}
                    onClick={() => {
                      setAddNewImagesIn4(true)
                      setFetchingNewImages(true)
                    }}
                    title="Add"
                  >
                    <span>+</span>
                  </div>

                  {editedOptions.length === 0 && (
                    <div style={{ color: "#888" }}>No images left</div>
                  )}
                </div>
              ) : (
                <>
                  <div className="draggable-container">
                    {row.options.map((img, idx) => (
                      <img
                        key={`${img}-${idx}`}
                        src={img}
                        alt=""
                        width={60}
                        height={60}
                        className="draggable-image"
                        style={{ margin: "0 2px" }}
                      />
                    ))}
                  </div>
                </>

              ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            minWidth: "40%",
          },
          {
            name: "Actions",
            cell: (row) =>
              editRowId === row.id ? (
                <QuestionActions
                  isEditing={true}
                  onUpdate={() => handleUpdateMini4(row)}
                  onCancel={handleCancel}
                  row={row}
                  disableUpdate={
                    editedQuestion.trim() === row.question.trim() &&
                    JSON.stringify(editedOptions) ===
                    JSON.stringify(row.options || [])
                  }
                />
              ) : (
                <QuestionActions
                  isEditing={false}
                  onEdit={() => handleEditMini4(row)}
                  onDelete={() => handleDelete(row)}
                  row={row}
                />
              ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            minWidth: "15%",
          },
        ]
        : selectedMiniGame === "5"
          ? [
            {
              name: "Question",
              cell: (row) =>
                editRowId === row.id ? (
                  <textarea
                    value={editedQuestion}
                    onChange={(e) => setEditedQuestion(e.target.value)}
                    rows={2}
                    style={{ width: "100%", minHeight: 40 }}
                  />
                ) : (
                  row.question
                ),
              wrap: true,
              width: "50%",
            },
            {
              name: "MCQ",
              cell: (row) =>
                editRowId === row.id ? (
                  <div>
                    <div style={{ color: "#888", fontSize: 13, marginBottom: 4 }}>
                      (one per line)
                    </div>
                    <textarea
                      value={editedMCQ.join("\n")}
                      onChange={(e) => setEditedMCQ(e.target.value.split("\n"))}
                      rows={row.mcq?.length || 3}
                      style={{ width: "100%", minHeight: 60 }}
                    />
                  </div>
                ) : Array.isArray(row.mcq) ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      fontWeight: "normal",
                    }}
                  >
                    {row.mcq.map((opt, idx) => (
                      <div key={idx} style={{ fontSize: "15px", paddingLeft: 4 }}>
                        <li>{opt}</li>
                      </div>
                    ))}
                  </div>
                ) : (
                  "-"
                ),
              width: "15%",
            },
            {
              name: "Answer",
              cell: (row) =>
                editRowId === row.id ? (
                  <input
                    type="text"
                    value={editedAnswer}
                    onChange={(e) => setEditedAnswer(e.target.value)}
                    style={{
                      width: "100%",
                      minWidth: 120,
                      padding: "6px 10px",
                      fontSize: 15,
                    }}
                  />
                ) : (
                  row.answer
                ),
              width: "15%",
            },
            {
              name: "Actions",
              cell: (row) =>
                editRowId === row.id ? (
                  <QuestionActions
                    isEditing={true}
                    onUpdate={() => handleUpdateMini5(row)}
                    onCancel={handleCancel}
                    row={row}
                    disableUpdate={
                      editedQuestion.trim() === (row.question || "").trim() &&
                      editedAnswer.trim() === (row.answer || "").trim() &&
                      JSON.stringify(editedMCQ) === JSON.stringify(row.mcq || [])
                    }
                  />
                ) : (
                  <QuestionActions
                    isEditing={false}
                    onEdit={() => handleEditMini5(row)}
                    onDelete={() => handleDelete(row)}
                    row={row}
                  />
                ),
              ignoreRowClick: true,
              allowOverflow: true,
              button: true,
              minWidth: "15%",
            },
          ]
          : selectedMiniGame === "6"
            ? [
              {
                name: "Paragraph",
                cell: (row) =>
                  editRowId === row.id ? (
                    <textarea
                      value={editedQuestion}
                      onChange={(e) => setEditedQuestion(e.target.value)}
                      rows={4}
                      style={{ width: "100%", minHeight: 120 }}
                    />
                  ) : (
                    row.paragraph
                  ),
                wrap: true,
                width: "35%",
              },
              {
                name: "MCQs",
                cell: (row) =>
                  editRowId === row.id ? (
                    <div>
                      <div style={{ color: "#888", fontSize: 13, marginBottom: 4 }}>
                        (one per line)
                      </div>
                      <textarea
                        value={editedMCQ.join("\n")}
                        onChange={(e) => setEditedMCQ(e.target.value.split("\n"))}
                        rows={row.mcqs?.length || 4}
                        style={{
                          width: "100%",
                          minHeight: 120,
                          fontWeight: "normal",
                          minWidth: "420px",
                        }}
                      />
                    </div>
                  ) : Array.isArray(row.mcqs) ? (
                    <div
                      style={{
                        display: "flex",
                        minHeight: 80,
                        flexDirection: "column",
                        gap: "12%",
                      }}
                    >
                      {row.mcqs.map((opt, idx) => (
                        <div key={idx}>
                          <li>{opt}</li>
                        </div>
                      ))}
                    </div>
                  ) : (
                    "-"
                  ),
                width: "32%",
                wrap: true,
              },
              {
                name: "Correct Answer",
                cell: (row) =>
                  editRowId === row.id ? (
                    <textarea
                      value={editedAnswer}
                      onChange={(e) => setEditedAnswer(e.target.value)}
                      rows={1}
                      style={{ width: "100%", minHeight: 80 }}
                    />
                  ) : (
                    row.correctAnswer
                  ),
                width: "15%",
                wrap: true,
              },
              {
                name: "Actions",
                cell: (row) =>
                  editRowId === row.id ? (
                    <QuestionActions
                      isEditing={true}
                      onUpdate={() => handleUpdateMini6(row)}
                      onCancel={handleCancel}
                      row={row}
                      disableUpdate={
                        editedQuestion.trim() === (row.paragraph || "").trim() &&
                        editedAnswer.trim() === (row.correctAnswer || "").trim() &&
                        JSON.stringify(editedMCQ) === JSON.stringify(row.mcqs || [])
                      }
                    />
                  ) : (
                    <QuestionActions
                      isEditing={false}
                      onEdit={() => handleEditMini6(row)}
                      onDelete={() => handleDelete(row)}
                      row={row}
                    />
                  ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
                width: "15%",
              },
            ]
            : selectedMiniGame === "7"
              ? [
                {
                  name: "Description",
                  cell: (row) =>
                    editRowId === row.id ? (
                      <textarea
                        type="text"
                        value={editedQuestion}
                        onChange={(e) => setEditedQuestion(e.target.value)}
                        style={{
                          width: "100%",
                          minWidth: 120,
                          padding: "6px 10px",
                          fontSize: 15,
                          minHeight: 80,
                        }}
                      />
                    ) : (
                      row.Description
                    ),
                  wrap: true,
                  width: "37%",
                },
                {
                  name: (
                    <span className="header-center">
                      <span className="header-white">Weight</span>
                      <br />
                      <span className="header-blue">Blue</span>
                    </span>
                  ),
                  cell: (row) =>
                    editRowId === row.id ? (
                      <input
                        type="number"
                        value={editedWeightBlue}
                        onChange={(e) => setEditedWeightBlue(e.target.value)}
                        style={{
                          width: "100%",
                          minWidth: 80,
                          padding: "6px 10px",
                          fontSize: 15,
                        }}
                      />
                    ) : (
                      row.WeightBlue
                    ),
                  width: "8%",
                },
                {
                  name: (
                    <span className="header-center">
                      <span className="header-white">Weight</span>
                      <br />
                      <span className="header-green">Green</span>
                    </span>
                  ),
                  cell: (row) =>
                    editRowId === row.id ? (
                      <input
                        type="number"
                        value={editedWeightGreen}
                        onChange={(e) => setEditedWeightGreen(e.target.value)}
                        style={{
                          width: "100%",
                          minWidth: 80,
                          padding: "6px 10px",
                          fontSize: 15,
                        }}
                      />
                    ) : (
                      row.WeightGreen
                    ),
                  width: "8%",
                },
                {
                  name: (
                    <span className="header-center">
                      <span className="header-white">Weight</span>
                      <br />
                      <span className="header-red">Red</span>
                    </span>
                  ),
                  cell: (row) =>
                    editRowId === row.id ? (
                      <input
                        type="number"
                        value={editedWeightRed}
                        onChange={(e) => setEditedWeightRed(e.target.value)}
                        style={{
                          width: "100%",
                          minWidth: 80,
                          padding: "6px 10px",
                          fontSize: 15,
                        }}
                      />
                    ) : (
                      row.WeightRed
                    ),
                  width: "8%",
                },
                {
                  name: (
                    <span className="header-center">
                      <span className="header-white">Weight</span>
                      <br />
                      <span className="header-yellow">Yellow</span>
                    </span>
                  ),
                  cell: (row) =>
                    editRowId === row.id ? (
                      <input
                        type="number"
                        value={editedWeightYellow}
                        onChange={(e) => setEditedWeightYellow(e.target.value)}
                        style={{
                          width: "100%",
                          minWidth: 80,
                          padding: "6px 10px",
                          fontSize: 15,
                        }}
                      />
                    ) : (
                      row.WeightYellow
                    ),
                  width: "8%",
                },
                {
                  name: (
                    <span className="header-center">
                      <span className="header-white">s1</span>
                      <br />
                      <span className="header-yellow">Limit</span>
                    </span>
                  ),
                  cell: (row) =>
                    editRowId === row.id ? (
                      <input
                        type="number"
                        value={editedS1Limit}
                        onChange={(e) => setEditedS1Limit(e.target.value)}
                        style={{
                          width: "100%",
                          minWidth: 80,
                          padding: "6px 10px",
                          fontSize: 15,
                        }}
                      />
                    ) : (
                      row.s1Limit
                    ),
                  width: "8%",
                },
                {
                  name: (
                    <span className="header-center">
                      <span className="header-white">s2</span>
                      <br />
                      <span className="header-yellow">Limit</span>
                    </span>
                  ),
                  cell: (row) =>
                    editRowId === row.id ? (
                      <input
                        type="number"
                        value={editedS2Limit}
                        onChange={(e) => setEditedS2Limit(e.target.value)}
                        style={{
                          width: "100%",
                          minWidth: 80,
                          padding: "6px 10px",
                          fontSize: 15,
                        }}
                      />
                    ) : (
                      row.s2Limit
                    ),
                  width: "8%",
                },
                {
                  name: "Actions",
                  cell: (row) =>
                    editRowId === row.id ? (
                      <QuestionActions
                        isEditing={true}
                        onUpdate={() => handleUpdateMini7(row)}
                        onCancel={handleCancel}
                        row={row}
                        disableUpdate={
                          editedQuestion.trim() === (row.Description || "").trim() &&
                          editedWeightBlue === (row.WeightBlue?.toString() || "") &&
                          editedWeightGreen === (row.WeightGreen?.toString() || "") &&
                          editedWeightRed === (row.WeightRed?.toString() || "") &&
                          editedWeightYellow ===
                          (row.WeightYellow?.toString() || "") &&
                          editedS1Limit === (row.s1Limit?.toString() || "") &&
                          editedS2Limit === (row.s2Limit?.toString() || "")
                        }
                      />
                    ) : (
                      <QuestionActions
                        isEditing={false}
                        onEdit={() => handleEditMini7(row)}
                        onDelete={() => handleDelete(row)}
                        row={row}
                      />
                    ),
                  ignoreRowClick: true,
                  allowOverflow: true,
                  button: true,
                  width: "15%",
                },
              ]
              : selectedMiniGame === "8"
                ? [
                  {
                    name: "Sequence",
                    cell: (row) => <DraggableImagesMini8
                      row={row}
                      isEditing={editRowId === row.id}
                      editedSequence={editedSequence}
                      setEditedSequence={setEditedSequence}
                    />,
                    width: "80%",
                    wrap: true,
                  },
                  {
                    name: "Actions",
                    cell: (row) =>
                      editRowId === row.id ? (
                        <QuestionActions
                          isEditing={true}
                          onUpdate={() => handleUpdateMini8(row)}
                          onCancel={handleCancel}
                          row={row}
                          disableUpdate={
                            JSON.stringify(editedSequence) ===
                            JSON.stringify(row.sequence || [])
                          }
                        />
                      ) : (
                        <QuestionActions
                          isEditing={false}
                          onDelete={() => handleDelete(row)}
                          row={row}
                          onEdit={(row) => handleEditMini8(row)}
                        // hideEdit={true}
                        />
                      ),
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                    minWidth: "15%",
                  },
                ]
                : selectedMiniGame === "9"
                  ? [
                    {
                      name: "Chart Type",
                      cell: (row) =>
                        editRowId === row.id ? (
                          <select
                            value={editedChartType}
                            onChange={(e) => setEditedChartType(e.target.value)}
                            style={{ width: "100%", minWidth: 120, padding: "6px 10px" }}
                          >
                            <option value="verticalbar">Vertical Bar</option>
                            <option value="horizontalbar">Horizontal Bar</option>
                            <option value="pie">Pie</option>
                          </select>
                        ) : (
                          row.chartType
                        ),
                      width: "10%",
                    },
                    {
                      name: "Question",
                      cell: (row) =>
                        editRowId === row.id ? (
                          <textarea
                            value={editedMini9Question}
                            onChange={(e) => setEditedMini9Question(e.target.value)}
                            rows={2}
                            style={{ width: "100%", minHeight: 40 }}
                          />
                        ) : (
                          row.question
                        ),
                      width: "17%",
                      wrap: true,
                    },
                    {
                      name: "MCQs",
                      cell: (row) =>
                        editRowId === row.id ? (
                          <div>
                            <div style={{ color: "#888", fontSize: 13, marginBottom: 4 }}>
                              (one per line, max 4)
                            </div>
                            <textarea
                              value={editedMini9MCQ.join("\n")}
                              onChange={(e) =>
                                setEditedMini9MCQ(e.target.value.split("\n"))
                              }
                              rows={row.mcqs?.length || 4}
                              style={{ width: "100%", minHeight: 60 }}
                            />
                          </div>
                        ) : Array.isArray(row.mcqs) ? (
                          <ol style={{ paddingLeft: 18 }}>
                            {row.mcqs.map((opt, idx) => (
                              <li key={idx}>{opt}</li>
                            ))}
                          </ol>
                        ) : (
                          "-"
                        ),
                      width: "12%",
                    },
                    {
                      name: "Answer",
                      cell: (row) =>
                        editRowId === row.id ? (
                          <input
                            type="text"
                            value={editedMini9Answer}
                            onChange={(e) => setEditedMini9Answer(e.target.value)}
                            style={{ width: "100%", minWidth: 80, padding: "6px 10px" }}
                          />
                        ) : (
                          row.answer
                        ),
                      width: "12%",
                    },
                    {
                      name: "Title",
                      cell: (row) =>
                        editRowId === row.id ? (
                          <input
                            type="text"
                            value={editedMini9Title}
                            onChange={(e) => setEditedMini9Title(e.target.value)}
                            style={{ width: "100%", minWidth: 120, padding: "6px 10px" }}
                          />
                        ) : (
                          row.title
                        ),
                      width: "12%",
                    },
                    {
                      name: "X Axis",
                      cell: (row) =>
                        editRowId === row.id ? (
                          <div>
                            <div style={{ color: "#888", fontSize: 13, marginBottom: 4 }}>
                              (one per line)
                            </div>
                            <textarea
                              value={
                                Array.isArray(editedMini9XAxis)
                                    ? editedMini9XAxis.map(item => String(item)).join("\n")
                                  : ""
                              }
                              onChange={(e) => {
                                const val = e.target.value.split("\n");
                                setEditedMini9XAxis(val);
                              }}
                              rows={row.xaxis?.length || 4}
                              style={{ width: "100%", minHeight: 60 }}
                              placeholder={
                                editedChartType === "horizontalbar"
                                  ? "Enter numbers, one per line"
                                  : "Enter strings, one per line"
                              }
                            />
                          </div>
                        ) : Array.isArray(row.xaxis) ? (
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                            {row.xaxis.map((item, idx) => (
                              <span key={idx} style={{ fontWeight: 500 }}>
                                {item}
                                {idx < row.xaxis.length - 1 && <span>,&nbsp;</span>}
                              </span>
                            ))}
                          </div>
                        ) : (
                          "-"
                        ),
                      width: "12%",
                    },
                    {
                      name: "Y Axis",
                      cell: (row) =>
                        editRowId === row.id ? (
                          <div>
                            <div style={{ color: "#888", fontSize: 13, marginBottom: 4 }}>
                              (one per line)
                            </div>
                            <textarea
                              value={
                                Array.isArray(editedMini9YAxis)
                                    ? editedMini9YAxis.map(item => String(item)).join("\n")
                                  : ""
                              }
                              onChange={(e) => {
                                const val = e.target.value.split("\n");
                                setEditedMini9YAxis(
                                  editedChartType === "horizontalbar"
                                    ? val
                                      : val
                                );
                              }}
                              rows={row.yaxis?.length || 4}
                              style={{ width: "100%", minHeight: 60 }}
                              placeholder={
                                editedChartType === "horizontalbar"
                                  ? "Enter strings, one per line"
                                  : "Enter numbers, one per line"
                              }
                            />
                          </div>
                        ) : Array.isArray(row.yaxis) ? (
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                            {row.yaxis.map((item, idx) => (
                              <span key={idx} style={{ fontWeight: 500 }}>
                                {item}
                                {idx < row.yaxis.length - 1 && <span>,&nbsp;</span>}
                              </span>
                            ))}
                          </div>
                        ) : (
                          "-"
                        ),
                      width: "12%",
                    },
                    {
                      name: "Actions",
                      cell: (row) =>
                        editRowId === row.id ? (
                          <QuestionActions
                            isEditing={true}
                            onUpdate={() => handleUpdateMini9(row)}
                            onCancel={handleCancel}
                            row={row}
                            disableUpdate={
                              editedChartType === (row.chartType || "") &&
                              editedMini9Question.trim() ===
                              (row.question || "").trim() &&
                              editedMini9Answer.trim() === (row.answer || "").trim() &&
                              editedMini9Title.trim() === (row.title || "").trim() &&
                              JSON.stringify(editedMini9MCQ) ===
                              JSON.stringify(row.mcqs || []) &&
                              JSON.stringify(editedMini9XAxis) ===
                              JSON.stringify(row.xaxis || []) &&
                              JSON.stringify(editedMini9YAxis) ===
                              JSON.stringify(row.yaxis || [])
                            }
                          />
                        ) : (
                          <QuestionActions
                            isEditing={false}
                            onEdit={() => handleEditMini9(row)}
                            onDelete={() => handleDelete(row)}
                            row={row}
                          />
                        ),
                      ignoreRowClick: true,
                      allowOverflow: true,
                      button: true,
                      minWidth: "11%",
                    },
                  ]
                  : [
                    {
                      name: "Correct Sequence",
                      cell: (row) =>
                        editRowId === row.id ? (
                          <textarea
                            value={editedCorrectSequence.join("\n")}
                            onChange={(e) =>
                              setEditedCorrectSequence(
                                e.target.value.split("\n").map(Number)
                              )
                            }
                            rows={row.correctSequence?.length || 3}
                            style={{
                              width: "100%",
                              minHeight: 60,
                              borderRadius: 8,
                            }}
                            placeholder="Enter numbers, one per line"
                          />
                        ) : Array.isArray(row.correctSequence) ? (
                          <div
                            style={{
                              display: "flex",
                              gap: 10,
                              alignItems: "center",
                              borderRadius: 8,
                              padding: "8px 12px",
                            }}
                          >
                            {row.correctSequence.map((num, idx) => (
                              <span
                                key={idx}
                                style={{
                                  fontWeight: 600,
                                  color: "#218838",
                                  fontSize: 18,
                                }}
                              >
                                {num}
                                {idx < row.correctSequence.length - 1 && (
                                  <span style={{ color: "#28a745", margin: "0 4px" }}>
                                    →
                                  </span>
                                )}
                              </span>
                            ))}
                          </div>
                        ) : (
                          "-"
                        ),
                      width: "30%",
                      wrap: true,
                    },
                    {
                      name: "Wrong Sequence",
                      cell: (row) =>
                        editRowId === row.id ? (
                          <textarea
                            value={editedWrongSequence.join("\n")}
                            onChange={(e) =>
                              setEditedWrongSequence(
                                e.target.value.split("\n").map(Number)
                              )
                            }
                            rows={row.wrongSequence?.length || 3}
                            style={{
                              width: "100%",
                              minHeight: 60,
                              borderRadius: 8,
                            }}
                            placeholder="Enter numbers, one per line"
                          />
                        ) : Array.isArray(row.wrongSequence) ? (
                          <div
                            style={{
                              display: "flex",
                              gap: 10,
                              alignItems: "center",
                              borderRadius: 8,
                              padding: "8px 12px",
                            }}
                          >
                            {row.wrongSequence.map((num, idx) => (
                              <span
                                key={idx}
                                style={{
                                  fontWeight: 600,
                                  color: "#c82333",
                                  fontSize: 18,
                                }}
                              >
                                {num}
                                {idx < row.wrongSequence.length - 1 && (
                                  <span style={{ color: "#dc3545", margin: "0 4px" }}>
                                    →
                                  </span>
                                )}
                              </span>
                            ))}
                          </div>
                        ) : (
                          "-"
                        ),
                      width: "50%",
                      wrap: true,
                    },
                    {
                      name: "Actions",
                      cell: (row) =>
                        editRowId === row.id ? (
                          <QuestionActions
                            isEditing={true}
                            onUpdate={() => handleUpdateMini10(row)}
                            onCancel={handleCancel}
                            row={row}
                            disableUpdate={
                              JSON.stringify(editedCorrectSequence) ===
                              JSON.stringify(row.correctSequence || []) &&
                              JSON.stringify(editedWrongSequence) ===
                              JSON.stringify(row.wrongSequence || [])
                            }
                          />
                        ) : (
                          <QuestionActions
                            isEditing={false}
                            onEdit={() => handleEditMini10(row)}
                            onDelete={() => handleDelete(row)}
                            row={row}
                          />
                        ),
                      ignoreRowClick: true,
                      allowOverflow: true,
                      button: true,
                      minWidth: "15%",
                    },
                  ];

  return (
    <Container fluid>
      <Row className="mt-4 mb-2">
        <Col md={4}>
          <MiniGameFilter
            selectedMiniGame={selectedMiniGame}
            onChange={handleMiniGameChange}
            options={filterMiniGames}
          />
        </Col>
        <Col md={8} className="d-flex justify-content-end align-items-end">
          {renderAddButton()}
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            {selectedMiniGame && (
              <div className="responsive-table-container">
                <DataTable
                  key={`datatable-${selectedMiniGame}`} // Force remount when selectedMiniGame changes
                  columns={columns}
                  data={questions}
                  customStyles={customStyles}
                  progressPending={loading}
                  pagination
                  paginationPerPage={defaultPerPage}
                  highlightOnHover
                  paginationRowsPerPageOptions={[10, 20, 50]}
                  className="questionnaire-data-table"
                />
              </div>
            )}
          </Card>
        </Col>
      </Row>

      <Modal isOpen={addNewImagesIn4} toggle={() => setAddNewImagesIn4(!addNewImagesIn4)} centered size="xl">
        <ModalHeader className="mini4-modal-header">Add New MiniGame 4 Images</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Available Images</Label>
            <div className="image-grid">
              {fetchingNewImages ?
                <>Loader</> :
                <>
                  {
                    allNewImages.map((img) => {
                      const isSelected = newlySelectedImages.find(
                        (i) => i.name === img.name
                      ) || editedOptions.includes(img.url);

                      return (
                        <div
                          key={img.name}
                          className={`image-thumb selectable ${isSelected ? "selected" : ""
                            }`}
                          title={img.name}
                        >
                          <img src={img.url} alt={img.name} />
                          <div className="img-label">{img.name}</div>
                          {!isSelected && (
                            <div
                              className="add-badge"
                              onClick={() => handleAddNewImage(img)}
                              title="Add"
                            >
                              +
                            </div>
                          )}
                          {isSelected && (
                            <div className="add-badge added" title="Already added">
                              ✓
                            </div>
                          )}
                        </div>
                      );
                    })
                  }
                </>

              }

            </div>
            <small>Select images to add as options. Click the + to add.</small>
          </FormGroup>
        </ModalBody>
      </Modal>

      <QuestionnaireModalRenderer
        selectedMiniGame={selectedMiniGame}
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
        handleQuestionAdded={handleQuestionAdded}
      />
    </Container>
  );
}
